/**
 * Authorization Settings — now part of the unified Settings (/settings/authorisation).
 * Keep the old path as a redirect so bookmarks, header & profile links still work.
 */

import type { RouteRecordRaw } from 'vue-router';

export const authorizationSettingsRoutes: RouteRecordRaw[] = [
  {
    path: '/pages/authorization-settings',
    redirect: '/settings/authorisation'
  }
];

export default authorizationSettingsRoutes;
